import React, { createContext, useContext } from "react"
import { Rule, RuleSchema } from "layouts/charging-rules/interface/Rules.ts"
import { Action } from "layouts/charging-rules/state/rulesRuducer.tsx"

interface ChargingRulesContextType {
    rules: Rule[],
    dispatch: React.ActionDispatch<[action: Action]>
    schema: typeof RuleSchema
    setSchema: React.Dispatch<React.SetStateAction<typeof RuleSchema>>
    fetchListChargingRules: RequestFunction
    listChargingRulesLoading: boolean
    listChargingRulesSuccess: boolean | null
    fetchUpdateChargingRules: RequestFunction
    updateChargingRuleLoading: boolean
    updateChargingRulesStatus: boolean | null
    errorEnergy: boolean
    setErrorEnergy: React.Dispatch<React.SetStateAction<boolean>>
    errorDuration: boolean
    setErrorDuration: React.Dispatch<React.SetStateAction<boolean>>
    rfidCardRuleId: string | null
    allDaysSelected: boolean
    allHoursSelected: boolean
    noDaysSelected: boolean
    noHoursSelected: boolean
    isRuleChanged: boolean
    setIsRuleChanged: React.Dispatch<React.SetStateAction<boolean>>
    setRfidCardRuleId: React.Dispatch<React.SetStateAction<string | null>>
    getRfidCardRuleLoading: boolean
    ruleSchemaCompany: typeof RuleSchema
}

export const ChargingRulesPageContext = createContext<
    ChargingRulesContextType | undefined
>(undefined)

export const useChargingRulesContext = () => {
    const context = useContext(ChargingRulesPageContext)
    if (context === undefined) {
        throw new Error(
            "useChargingRulesContext doit être utilisé à l'intérieur de ChargingRulesPageContext"
        )
    }
    return context
}
